var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("BjDialogList", {
    ref: "dialogList",
    attrs: {
      width: "80%",
      config: _vm.dialogConfig,
      "search-btn-hide": true,
      "show-tags": false,
      multiple: null,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }